import * as React from 'react';
import { useState } from 'react';
import { useLogin, useNotify, Notification, Form } from 'react-admin';
import {
  FormControl,
  TextField,
  Grid,
  Card,
  useMediaQuery,
  Box,
  Switch,
  FormGroup,
  FormControlLabel,
  IconButton,
  createTheme,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { validatePhone } from '../../ultis/regex/Regex';
import {
  ClearMessageOtp,
  showOtpGgAuthen,
  showOtpLoginModal,
} from '../../redux/creates-action/OtpAction';
import { loginGraphql, verifyPhoneLogin } from '../../services/Login';
import { useNavigate } from 'react-router-dom';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { getMerchantHandleToken } from '../../services/Merchant';
import TokenService from '../../services/TokenService';
import Color from '../layout/color/Color';

const theme = createTheme();

const Login = () => {
  const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));
  const [password, setPassword] = useState('');
  const [confirmPassword, setConFirmPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [isPhoneError, setIsPhoneError] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [isHavePassword, setIsHavePassword] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [authenType, setAuthenType] = useState(null);
  const [errorPhoneMessage, setErrorPhoneMessage] = useState('');
  const [message, setMessage] = useState('');

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const login = useLogin();
  const notify = useNotify();

  const dispatch = useDispatch();
  const datax = useSelector((state) => state.otp.data);
  let navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('userToken') !== null) {
      navigate('/dashboard', { replace: true });
    }
  });

  useEffect(() => {
    if (datax.next === true) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      setActiveStep(0);
    }
  }, [datax.next]);

  useEffect(() => {
    if (activeStep === 1) {
      notify('Verify successful!', { type: 'success' });
    }

  }, [activeStep]);

  useEffect(() => {
    setActiveStep(0);
  }, []);

  useEffect(() => {
    if (datax.notify !== '') {
      setMessage(datax.notify);
    }

  }, [datax.notify]);

  useEffect(() => {
    if (message !== '') {
      notify(message, { type: datax.style });
      dispatch(ClearMessageOtp());
      setMessage('');
    }

  }, [message]);

  const handleNext = (e) => {
    if (phone === '') {
      notify('Phone required!', { type: 'error' });
    } else {
      if (isPhoneError === false) {
        const data = {
          phone: phone,
        };
        verifyPhoneLogin(data)
          .then((result) => {
            if (result !== null) {
              setAuthenType(result.authentype);
              setIsHavePassword(result.isHasPass);
              if (result.authentype === 1) {
                dispatch(showOtpLoginModal(phone, 'OTP_LOGIN'));
              } else {
                if (result.authentype === 2) {
                  dispatch(showOtpGgAuthen(phone, authenType, 'OTP_LOGIN'));
                } else {
                  notify('Have an error', { type: 'warning' });
                }
              }
            }
          })
          .catch((err) => {
            const response = JSON.parse(JSON.stringify(err.response));
            const errors = response.errors;
            let errorMessage = '';
            errors.map((error) => {
              errorMessage += error.message;
              return error;
            });
            setErrorPhoneMessage(errorMessage);
            setIsPhoneError(true);
          });
      }
      // else {
      //   notify(errorPhoneMessage, { type: 'warning' });
      // }
    }
  };

  const handleSubmit = (e) => {
    const loginUser = {
      data: {
        phone: phone,
        password: password,
        isHasPass: isHavePassword,
      },
    };
    if (isHavePassword === true) {
      loginGraphql(loginUser)
        .then((result) => {
          if (result !== null) {
            let token = result.token;
            let role = result.role;
            getMerchantHandleToken(token)
              .then((result) => {
                if (result !== null) {
                  TokenService.updateLocalMerchantID(result[0].id);
                  login({ phone, token, role })
                    .then((result) => {
                      navigate('/dashboard', { replace: true });
                      navigate(0);
                      notify('Login Success', { type: 'success' });
                    })
                    .catch(() => notify('Invalid phone/email or password'));
                }
              })
              .catch((errors) => {
                let err = JSON.parse(JSON.stringify(errors, undefined, 2));
                if (err.response !== undefined) {
                  notify(err.response.errors[0].message, { type: 'error' });
                } else {
                  notify('Server error, please try again', { type: 'error' });
                }
              });
          }
        })
        .catch((errors) => {
          let err = JSON.parse(JSON.stringify(errors, undefined, 2));
          if (err.response !== undefined) {
            notify(err.response.errors[0].message, { type: 'error' });
          } else {
            notify('Server error, please try again', { type: 'error' });
          }
        });
    } else {
      if (password === confirmPassword) {
        loginGraphql(loginUser)
          .then((result) => {
            if (result !== null) {
              let token = result.token;
              let role = result.role;
              getMerchantHandleToken(token)
                .then((result) => {
                  if (result !== null) {
                    TokenService.updateLocalMerchantID(result[0].id);
                    login({ phone, token, role })
                      .then((result) => {
                        navigate('/dashboard', { replace: true });
                        navigate(0);
                      })
                      .catch(() => notify('Invalid phone/email or password'));
                  }
                })
                .catch((errors) => {
                  let err = JSON.parse(JSON.stringify(errors, undefined, 2));
                  if (err.response !== undefined) {
                    notify(err.response.errors[0].message, { type: 'error' });
                  } else {
                    notify('Server error, please try again', { type: 'error' });
                  }
                });
            }
          })
          .catch((errors) => {
            let err = JSON.parse(JSON.stringify(errors, undefined, 2));
            if (err.response !== undefined) {
              notify(err.response.errors[0].message, { type: 'error' });
            } else {
              notify('Server error, please try again', { type: 'error' });
            }
          });
      } else {
        notify('Invalid confirm password');
      }
    }
  };

  const handleChangePhoneNumber = (e) => {
    let value = e.target.value;
    handleValidatePhone(value);
  };

  function handleValidatePhone(phone) {
    let result = validatePhone(phone);
    if (!result && phone !== '') {
      setPhone(phone);
      setIsPhoneError(true);
      setErrorPhoneMessage('Your phone number is invalid');
    } else {
      setIsPhoneError(false);
      setErrorPhoneMessage('');
      setPhone(phone);
    }
  }

  return (
    <div>
      <header className="header-section register login">
        <div className="overlay">
          <div className="container">
            <div className="row d-flex header-area">
              <nav className="navbar d-flex justify-content-between navbar-expand-lg navbar-dark">
                <Link
                  className="navbar-brand"
                  to="/"
                  style={{
                    fontWeight: 600,
                    fontSize: '24px',
                    color: '#1a4dbe',
                  }}
                >
                  <span className="logo-home" />
                  APO
                  <span
                    style={{
                      fontWeight: 600,
                      fontSize: '24px',
                      color: '#055c2d',
                    }}
                  >
                    LLO
                  </span>
                </Link>
                <div className="d-flex align-items-center justify-content-end">
                  <ul className="navbar-nav">
                    <li className="nav-item">Don't have an account</li>
                  </ul>
                  <div className="right-area header-action d-flex align-items-center">
                    <Link to="/signup" className="cmn-btn">
                      Register
                    </Link>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </header>
      <section className="sign-in-up login">
        <div className="overlay  pb-120" style={{ paddingTop: '50px' }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="form-content">
                  <div className="section-header" style={{}}>
                    <h5 className="sub-title">Give yourself the Bankio Edge</h5>
                    <h2 className="title">Login Now</h2>
                  </div>
                  <Box maxWidth="sm" sx={{ justifyContent: 'center' }}>
                    <Card>
                      <Grid
                        container
                        direction="column"
                        alignItems="center"
                        sx={{ justifyContent: 'center' }}
                      >
                        <Grid item>
                          <Form>
                            <FormControl>
                              {activeStep === 0 ? (
                                <React.Fragment>
                                  <Grid
                                    container
                                    spacing={1}
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      pt: 0.5,
                                    }}
                                  >
                                    <Grid item xs={12}>
                                      <label
                                        style={{
                                          fontSize: '20px',
                                          fontWeight: '500',
                                          color: '#212529',
                                          fontFamily: 'Jost, sans-serif',
                                          marginBottom: '8px',
                                          marginTop: '8px',
                                        }}
                                      >
                                        Mobile Number
                                      </label>
                                      <TextField
                                        fullWidth
                                        label="Phone Number"
                                        variant="outlined"
                                        value={phone}
                                        error={isPhoneError}
                                        helperText={errorPhoneMessage}
                                        onChange={handleChangePhoneNumber}
                                        size="large"
                                        required
                                      />
                                    </Grid>
                                    <Grid
                                      container
                                      item
                                      xs={12}
                                      sx={{
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: matchDownMD
                                          ? 'center'
                                          : 'space-between',
                                        alignItems: 'center',
                                        mx: `${matchDownMD ? '3rem' : '5rem'}`,
                                      }}
                                    >
                                      <FormGroup>
                                        <FormControlLabel
                                          control={<Switch defaultChecked size="small" />}
                                          label="Remember login"
                                        />
                                      </FormGroup>

                                      <div>
                                        <Link
                                          to="/forgot-password"
                                          style={{ color: Color.Main }}
                                        >
                                          Forgot password?
                                        </Link>
                                      </div>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <div
                                        className="btn-area"
                                        style={{ marginBottom: '16px' }}
                                      >
                                        <button
                                          className="cmn-btn"
                                          onClick={handleNext}
                                          style={{
                                            fontSize: '20px',
                                            textAlign: 'center',
                                          }}
                                        >
                                          Verify OTP
                                        </button>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </React.Fragment>
                              ) : (
                                <React.Fragment>
                                  <Grid container spacing={2}>
                                    {isHavePassword === false ? (
                                      <React.Fragment>
                                        <Grid container item>
                                          <Grid
                                            item
                                            xs={12}
                                            sx={{
                                              mx: `${matchDownMD ? '3rem' : '5rem'
                                                }`,
                                              pr: `${matchDownMD ? '1rem' : 0}`,
                                              pt: 1,
                                            }}
                                          >
                                            <label
                                              style={{
                                                fontSize: '20px',
                                                fontWeight: '500',
                                                color: '#212529',
                                                fontFamily: 'Jost, sans-serif',
                                                marginBottom: '4px',
                                              }}
                                            >
                                              New Password
                                            </label>
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            sx={{
                                              mx: `${matchDownMD ? '3rem' : '5rem'
                                                }`,
                                              pr: `${matchDownMD ? '1rem' : 0}`,
                                            }}
                                          >
                                            <TextField
                                              fullWidth
                                              id="outlined-basic"
                                              label="New Password"
                                              variant="outlined"
                                              size="large"
                                              sx={{ mb: 2.5 }}
                                              required
                                              name="password"
                                              type={
                                                showPassword
                                                  ? 'text'
                                                  : 'password'
                                              }
                                              value={password}
                                              onChange={(e) =>
                                                setPassword(e.target.value)
                                              }
                                              InputProps={{
                                                endAdornment: (
                                                  <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={
                                                      handleClickShowPassword
                                                    }
                                                    edge="end"
                                                    size={
                                                      matchDownMD
                                                        ? 'small'
                                                        : 'medium'
                                                    }
                                                  >
                                                    {showPassword ? (
                                                      <Visibility />
                                                    ) : (
                                                      <VisibilityOff />
                                                    )}
                                                  </IconButton>
                                                ),
                                              }}
                                            />
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            sx={{
                                              mx: `${matchDownMD ? '3rem' : '5rem'
                                                }`,
                                              pr: `${matchDownMD ? '1rem' : 0}`,
                                              pt: 1,
                                            }}
                                          >
                                            <label
                                              style={{
                                                fontSize: '20px',
                                                fontWeight: '500',
                                                color: '#212529',
                                                fontFamily: 'Jost, sans-serif',
                                                marginBottom: '4px',
                                              }}
                                            >
                                              Confirm Password
                                            </label>
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            sx={{
                                              mx: `${matchDownMD ? '3rem' : '5rem'
                                                }`,
                                              pr: `${matchDownMD ? '1rem' : 0}`,
                                            }}
                                          >
                                            <TextField
                                              fullWidth
                                              id="outlined"
                                              label="Re-type Password"
                                              variant="outlined"
                                              required
                                              name="rePassword"
                                              type={
                                                showConfirmPassword
                                                  ? 'text'
                                                  : 'password'
                                              }
                                              value={confirmPassword}
                                              size="large"
                                              onChange={(e) =>
                                                setConFirmPassword(
                                                  e.target.value
                                                )
                                              }
                                              InputProps={{
                                                endAdornment: (
                                                  <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={
                                                      handleClickShowConfirmPassword
                                                    }
                                                    edge="end"
                                                    size={
                                                      matchDownMD
                                                        ? 'small'
                                                        : 'medium'
                                                    }
                                                  >
                                                    {showConfirmPassword ? (
                                                      <Visibility />
                                                    ) : (
                                                      <VisibilityOff />
                                                    )}
                                                  </IconButton>
                                                ),
                                              }}
                                            />
                                          </Grid>
                                        </Grid>
                                      </React.Fragment>
                                    ) : (
                                      <React.Fragment>
                                        <Grid
                                          container
                                          item
                                          sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                          }}
                                        >
                                          <Grid
                                            item
                                            xs={12}
                                            sx={{
                                              mx: `${matchDownMD ? '3rem' : '5rem'
                                                }`,
                                              pt: '0.5rem',
                                            }}
                                          >
                                            <label
                                              style={{
                                                fontSize: '20px',
                                                fontWeight: '500',
                                                color: '#212529',
                                                fontFamily: 'Jost, sans-serif',
                                                marginBottom: '8px',
                                              }}
                                            >
                                              Your Password
                                            </label>
                                            <TextField
                                              fullWidth
                                              label="Password"
                                              variant="outlined"
                                              type={
                                                showPassword
                                                  ? 'text'
                                                  : 'password'
                                              }
                                              value={password}
                                              onChange={(e) =>
                                                setPassword(e.target.value)
                                              }
                                              size="large"
                                              InputProps={{
                                                endAdornment: (
                                                  <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={
                                                      handleClickShowPassword
                                                    }
                                                    edge="end"
                                                    size={
                                                      matchDownMD
                                                        ? 'small'
                                                        : 'medium'
                                                    }
                                                  >
                                                    {showPassword ? (
                                                      <Visibility />
                                                    ) : (
                                                      <VisibilityOff />
                                                    )}
                                                  </IconButton>
                                                ),
                                              }}
                                              required
                                            />
                                          </Grid>
                                        </Grid>
                                      </React.Fragment>
                                    )}
                                    <Grid
                                      container
                                      item
                                      xs={12}
                                      sx={{
                                        display: 'flex',
                                        direction: 'row',
                                        justifyContent: matchDownMD
                                          ? 'center'
                                          : 'space-between',
                                        alignItems: 'center',
                                        mx: `${matchDownMD ? '3rem' : '5rem'}`,
                                      }}
                                    >
                                      <FormGroup>
                                        <FormControlLabel
                                          control={<Switch defaultChecked size="small" />}
                                          label="Remember login"
                                        />
                                      </FormGroup>
                                      <div>
                                        <Link
                                          to="/forgot-password"
                                          style={{ color: Color.Main }}
                                        >
                                          Forgot password?
                                        </Link>
                                      </div>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <div
                                        className="btn-area"
                                        style={{ marginBottom: '16px' }}
                                      >
                                        <button
                                          onClick={handleSubmit}
                                          className="cmn-btn"
                                          style={{
                                            fontSize: '20px',
                                            textAlign: 'center',
                                          }}
                                        >
                                          Submit Now
                                        </button>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </React.Fragment>
                              )}
                            </FormControl>
                            <Notification />
                          </Form>
                        </Grid>
                      </Grid>
                    </Card>
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
